<template>
  <div class="content">
    <div class="container-fluid">
      <div class="h2 text-center">
        WELCOME TO TONE NETWORKS
      </div>
      <div class="h5 text-center has-spaces">
        <span>SET THE TONE OF YOUR LIFE</span>
        <br>
        <span class="text-danger">OH! I SEE YOU ARE TONE NETWORKS ADMIN SO BE CAREFUL!</span>
        <br>
        <span class="text-muted">YOU CAN SET THE TONE OF OTHERS LIVES TOO</span>
      </div>
    </div>
  </div>
</template>
<script>
  export default {}
</script>

<style>
  .has-spaces{
    letter-spacing: 1px;
    word-spacing: 4px;
    line-height: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Home/HeroBanner.vue